import React from 'react'
import { DetailsList, DetailsListLayoutMode, IColumn, SelectionMode, ConstrainMode } from '@fluentui/react';
import { renderDateTime, renderUser } from '../../../helpers/HelperMethods';


const AppStoreSubmissionHistory = ({submissionItems}) => {

    const columns: IColumn[] = [
        {
            key: 'createdOn',
            name: 'Created on',
            fieldName: 'createdOn',
            minWidth: 80,
            maxWidth: 80,
            isRowHeader: false,
            isResizable: true,
            data: 'number',
            onRender: item => renderDateTime(item.createdOn, true)
        },
        {
            key: 'createdBy',
            name: 'Created by',
            fieldName: 'createdBy',
            minWidth: 250,
            maxWidth: 400,
            isRowHeader: false,
            isResizable: true,
            data: 'string',
            onRender: item => renderUser(item.createdBy)
        },
        {
            key: 'version',
            name: 'App version',
            fieldName: 'version',
            minWidth: 80,
            maxWidth: 80,
            isRowHeader: false,
            isResizable: true,
            data: 'string'
        },
        {
            key: 'deploymentType',
            name: 'Deployment Type',
            minWidth: 80,
            maxWidth: 80,
            isRowHeader: false,
            isResizable: true,
            data: 'string',
            onRender: item => <div>{item.isManagedItem ? 'Managed Item' : 'Template'}</div>
        },
        {
            key: 'status',
            name: 'Status',
            fieldName: 'status',
            minWidth: 100,
            maxWidth: 150,
            isRowHeader: false,
            isResizable: true,
            data: 'string',
        },
        {
            key: 'completedOn',
            name: 'Completed on',
            fieldName: 'completedOn',
            minWidth: 100,
            maxWidth: 100,
            isRowHeader: false,
            isResizable: true,
            data: 'number',
            onRender: item => renderDateTime(item.completedOn, true)
        },
        {
            key: 'comments',
            name: 'Comments',
            fieldName: 'comments',
            minWidth: 300,
            maxWidth: 600,
            isRowHeader: false,
            isResizable: true,
            isMultiline: true,
            data: 'string',
            onRender: item => <div dangerouslySetInnerHTML={{__html: item.comments}} />
        },
    ]

    const list = <DetailsList
                    items={submissionItems}
                    columns={columns}
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    selectionMode={SelectionMode.none}
                    styles={{root: {width: '100%'}}}
                    constrainMode={ConstrainMode.unconstrained}
                />

    return(
        <div style={{minWidth: 800}}>
            {list}
        </div>
    );
}
export default AppStoreSubmissionHistory


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/AppStoreSubmissionHistory.js